module.exports = __webpack_public_path__ + "images/lntegral_icon_succeed.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/lntegral_icon_succeed.png
// module id = 863
// module chunks = 130